// extracted by mini-css-extract-plugin
export default {"fixed":"FixedButton_fixed__SrapF"};